import { useMutation } from '@tanstack/react-query';

import { PricingPlanFormSchemaValues } from 'src/features/pricingPlan/utils/formSchema';
import { PricingPlan } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/pricing/pricing-plan/:planId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    data: Partial<PricingPlanFormSchemaValues>;
    planId: string;
    parkingId: string;
}
const mutationFn = ({ parkingId, planId, data }: DTO): Promise<PricingPlan> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, planId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePartialUpdatePricingPlan };
